import { checkIcon } from '@progress/kendo-svg-icons';
﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EventService } from '../../core/services/event.service';
import { faAt, faKey } from '@fortawesome/free-solid-svg-icons';
import { LoginModel } from 'app/models/login.model';
import { MembershipService } from 'app/core/services/membership.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { TokenModel } from 'app/models/token.model';
import { SecurityService } from 'app/services/security.service';
import { APPLICATION_ID } from 'app/models/constants';
import { SessionIdleService } from 'app/services/session-idle.service';

@Component({
  standalone: false,
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent extends NexusComponent {
  checkIcon = checkIcon;
    public login_model: LoginModel = new LoginModel();
    public token_model: TokenModel;
      public session_idle_expiry: boolean = true;
  public session_idle_expiry_mins: number =15;
    public form = new UntypedFormGroup({
        email: this.CreateRequiredFormControl(),
        password: this.CreateRequiredFormControl()
    });
    public form_result: NexusFormResultModel = new NexusFormResultModel();


    public faAt = faAt;
    public faKey = faKey;

    constructor(public membership_service: MembershipService, private router: Router, private route: ActivatedRoute,private security_service: SecurityService,private session_idle_service: SessionIdleService) {
        super();
      this.session_idle_expiry =this.session_idle_service.session_expired;
      this.session_idle_expiry_mins = this.session_idle_service.idle_ttl_minutes;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.login_model);
        });

        this.route.paramMap.subscribe(params => {
            if (params.has('email') && params.has('impersonation_id')) {
                this.login_model.email=params.get('email');
                this.login_model.impersonation_id = params.get('impersonation_id');
                this.submit(false);
            }

        });
            this.membership_service.GetToken().subscribe(
          data => {
            if(data) {
              this.membership_service.redirect_last_visited_page();
            }
          });
    }

    submit(validate=true) {
        this.form_result.Reset();

        if (validate && this.form.invalid) {
            this.form_result.Incomplete();
            return;
        }

        this.StartSpinner();
        this.login_model.device_token= this.security_service.GetDeviceToken();
        this.login_model.application_id= APPLICATION_ID;
        this.membership_service.Login(this.login_model).subscribe(
            data => {
                this.token_model = data;
                this.StopSpinner();
                if(data.mfa_required){
                  const otp_url = `otp/${data.otp_id}`;
                  this.router.navigate([otp_url]);
                  return;
                } else{

                  if (data.token) {
                    this.form_result.Success();
                    this.membership_service.SetToken(data);
                    this.membership_service.redirect_last_visited_page();
                }

                }





            },
            error => {
                this.form_result.Error(error);
                this.StopSpinner();
            });

    }

}
